export default __webpack_public_path__ + "static/article-finance-here-comes-christmas-d3baf118230588871331ff8d66ce0d16.jpg";